module.exports = __webpack_public_path__ + "static/img/4diamond-card@3x.cfd7e00d.png";